import store from "@streeteasy/redux-utilities";
import { combineReducers } from "redux";

import { FEATURE_NAME } from "../constants/namespace";
import contactFormReducer from "../slices/contactFormSlice";
import uiReducer from "../slices/uiSlice";

export default services => {
  store.addReducer(
    FEATURE_NAME,
    combineReducers({
      contactForm: contactFormReducer,
      ui: uiReducer
    })
  );

  store.addServices({
    [FEATURE_NAME]: services
  });

  return store;
};
